function Skeleton({ width, height, borderRadius = "8px", style }) {
  return (
    <div
      className="skeleton"
      style={{
        width: width || "100%",
        height: height || "20px",
        borderRadius,
        ...style,
      }}
    />
  );
}

export function GameCardSkeleton() {
  return (
    <div className="game-card skeleton-card">
      <Skeleton height="180px" borderRadius="8px 8px 0 0" />
      <div className="game-card-body" style={{ padding: "12px" }}>
        <Skeleton height="20px" width="70%" style={{ marginBottom: 8 }} />
        <Skeleton height="14px" width="40%" style={{ marginBottom: 12 }} />
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
          <Skeleton height="16px" width="50px" />
          <Skeleton height="16px" width="60px" />
        </div>
        <Skeleton height="34px" borderRadius="6px" />
      </div>
    </div>
  );
}

export function LibraryCardSkeleton() {
  return (
    <div className="library-card skeleton-card">
      <Skeleton height="160px" borderRadius="8px 8px 0 0" />
      <div className="library-card-body" style={{ padding: "12px" }}>
        <Skeleton height="18px" width="60%" style={{ marginBottom: 8 }} />
        <Skeleton height="14px" width="35%" style={{ marginBottom: 8 }} />
        <Skeleton height="16px" width="45%" style={{ marginBottom: 12 }} />
        <Skeleton height="30px" borderRadius="6px" />
      </div>
    </div>
  );
}

export function GameDetailSkeleton() {
  return (
    <div className="game-detail">
      <div className="game-detail-hero">
        <Skeleton height="400px" borderRadius="12px" style={{ flex: "1 1 50%", minWidth: 300 }} />
        <div className="game-detail-info" style={{ flex: "1 1 50%", minWidth: 300 }}>
          <Skeleton height="32px" width="80%" style={{ marginBottom: 12 }} />
          <Skeleton height="16px" width="30%" style={{ marginBottom: 8 }} />
          <Skeleton height="14px" width="40%" style={{ marginBottom: 16 }} />
          <Skeleton height="60px" style={{ marginBottom: 16 }} />
          <div style={{ display: "flex", gap: 16, marginBottom: 16 }}>
            <Skeleton height="20px" width="80px" />
            <Skeleton height="20px" width="100px" />
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            <Skeleton height="44px" width="160px" borderRadius="8px" />
            <Skeleton height="44px" width="160px" borderRadius="8px" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function CategoryChipSkeleton() {
  return <Skeleton height="36px" width="100px" borderRadius="20px" />;
}

export function TableRowSkeleton({ columns = 4 }) {
  return (
    <div className="admin-table-row" style={{ padding: "12px 16px" }}>
      {Array.from({ length: columns }).map((_, i) => (
        <Skeleton key={i} height="16px" width={i === 0 ? "70%" : "50%"} />
      ))}
    </div>
  );
}

export default Skeleton;
